<template>
  <ul class="some-search-letters">
    <li v-for="(item,idx) in letter" :key="idx">
      <label>
        <input :name="name" :value="item.name" type="radio" @click="update(item)">
        <span :class="{active: currentId === item.id}">{{item.name}}</span>
      </label>
    </li>
  </ul>
</template>
<script>
export default {
  props: {
    name: {
      type: String,
      default: ''
    },
    initLetter: {
      type: String,
      default: 'Colour Cosmetics'
    },
    letter: {
      type: [Array, Object]
    }
  },
  data () {
    return {
      currentId: null
      // letter: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'],
    }
  },
  methods: {
    update (item) {
      this.currentId = item.id || null
      this.$emit('update', item)
    }
  },
  mounted () {
    // 这里目前业务逻辑没什么用处，因为调用此组件的页面，传过来的数据都为空，所以都没法默认触发这里
    this.update(this.letter.length ? this.letter[0] : {})
  }
};
</script>
<style lang="stylus" scoped>
@import '~assets/styles/varibles.styl'

input
  position absolute
  clip rect(0,0,0,0)

ul
  font-size 0px
  li
    display inline-block
    label
      display: inline-block;
      span
        display inline-block

.some-search-letters
  margin-bottom: 14px;
  & li
    margin-right 10px
  & li label span
    font1()
    font-size 12px
    // width 100px
    padding 0 7px
    white-space nowrap
    text-align center
    color #232323
    line-height 32px
    cursor pointer
    &.active{
      border: 1px solid #21bdbb
      color $themeColor3
    }
</style>



// WEBPACK FOOTER //
// src/components/base/letterSearch/ConsumerLetter.vue